// extracted by mini-css-extract-plugin
module.exports = {"highlightImage":"_31ZNdC","wrapper":"jK7s1J","copyButton":"_3-n19J"};